import api from './index';

export const studyAPI = {
  getPoems: (params) => {
    return api.get('/api/study/poems', { params });
  },
  getPoemDetail: (id) => {
    return api.get(`/api/study/poem/${id}`);
  },
  getStudyRecords: (params) => {
    return api.get('/api/study/records', { params });
  },
  createStudyRecord: (data) => {
    return api.post('/api/study/records', data);
  },
  getStudyStats: () => {
    return api.get('/api/study/stats');
  },
  getTextbooks: () => {
    return api.get('/api/study/textbooks');
  },
  getGradesByTextbook: (textbookId) => {
    return api.get(`/api/study/textbooks/${textbookId}/grades`);
  },
  getUnitsByGrade: (gradeId) => {
    return api.get(`/api/study/grades/${gradeId}/units`);
  },
  getPoemsByUnit: (unitId) => {
    return api.get(`/api/study/units/${unitId}/poems`);
  },
  getOtherCategories: () => {
    return api.get('/api/study/other-categories');
  },
  getSubItemsByCategory: (categoryId) => {
    return api.get(`/api/study/other-categories/${categoryId}/sub-items`);
  },
  getPoemsBySubItem: (subItemId) => {
    return api.get(`/api/study/category-sub-items/${subItemId}/poems`);
  },
  addToLibrary: (poemIds) => {
    return api.post('/api/study/user-poem-library', { poemIds: poemIds });
  },
  getUserLibrary: () => {
    return api.get('/api/study/user-poem-library');
  },
  removeFromLibrary: (poemId) => {
    return api.delete(`/api/study/user-poem-library/${poemId}`);
  },
  saveRecording: (file, poemId, score) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('poemId', poemId);
    if (score !== undefined && score !== null) formData.append('score', score);
    return api.post('/api/study/recordings', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  getRecordingsByPoem: (poemId) => {
    return api.get(`/api/study/recordings/${poemId}`);
  },
  getRecordingAudio: (recordingId) => {
    return api.get(`/api/study/recordings/${recordingId}/audio`, { responseType: 'blob' });
  },
  getAllRecordings: () => {
    return api.get('/api/study/recordings');
  },
  getTreeData: () => {
    return api.get('/api/study/tree-data');
  },
  getCatalogTree: () => {
    return api.get('/api/study/catalog-tree');
  },
  searchPoems: (keyword) => {
    return api.get('/api/study/poems/search', { params: { keyword } });
  },
  getTextbookPlans: () => api.get('/api/study/payment/textbook-plans'),
  getTextbookMembership: () => api.get('/api/study/payment/textbook-membership'),
  createPaymentOrder: (data) => api.post('/api/study/payment/orders', data),
  getPaymentOrder: (orderNo) => api.get(`/api/study/payment/orders/${orderNo}`),
  mockConfirmPayment: (orderNo) => api.post(`/api/study/payment/orders/${orderNo}/mock-confirm`)
};